import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 36a4 4 0 0 0 3.998-4h-7.996A4 4 0 0 0 20 36Zm13.462-9.357c-1.208-1.297-3.467-3.25-3.467-9.643 0-4.856-3.405-8.744-7.996-9.697V6A2 2 0 1 0 18 6v1.303c-4.591.953-7.996 4.84-7.996 9.697 0 6.394-2.26 8.346-3.467 9.643A1.953 1.953 0 0 0 6 28c.007 1.025.811 2 2.006 2h23.988c1.195 0 2-.975 2.006-2a1.951 1.951 0 0 0-.538-1.357Z" })
});
export default SvgNotification;
